import { render } from "./Topsale.vue?vue&type=template&id=8eae76dc"
import script from "./Topsale.vue?vue&type=script&lang=js"
export * from "./Topsale.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__